import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import UserSignIn from "../header/UserSighin";
import DetailsWindow from "../containers/DetailsWindow";
import React from "react";
import CostumerCoupons from "./CostumerCoupons";
import { getStationToCustomer } from "../../server/Station";
import { MapPin, ChevronLeft } from "lucide-react";

const PersonalInformation = ({ parent }) => {
  const { stationId, role, isClientView } = useSelector((state) => ({
    stationId: state.user.stationId,
    role: state.user.role,
    isClientView: state.category.isClientView,
  }));

  const [stationName, setStationName] = useState(null);

  useEffect(() => {
    // Admins outside customer view keep the management station switcher instead.
    if ((role && !isClientView) || !stationId) return;
    getStationToCustomer(stationId)
      .then((res) => setStationName(res.data?.name ?? null))
      .catch(() => {});
  }, [stationId, role, isClientView]);

  return (
    <div className="private-area">
      <section id="info"></section>
      {stationName && (
        <div className="private-area__station-badge">
          <MapPin size={15} strokeWidth={2} aria-hidden />
          תחנת {stationName}
        </div>
      )}
      {parent === "cart" ? (
        <DetailsWindow title="פרטי לקוח">
          <NavLink className="btn-edit-details" to="/private-area/#info">
            שינוי פרטים
            <ChevronLeft size={14} strokeWidth={2.4} aria-hidden />
          </NavLink>
          <UserSignIn parentName="endShopping" />
        </DetailsWindow>
      ) : (
        <DetailsWindow title="פרטי לקוח">
          <UserSignIn parentName="privateArea" />
        </DetailsWindow>
      )}
      {parent === "cart" ? null : <CostumerCoupons />}{" "}
    </div>
  );
};

export default PersonalInformation;
